module.exports = __webpack_public_path__ + "static/media/logo2.58793e8f.png";